import React from "react";

// Tabla compacta de productos para usar dentro de los modales de aviso,
// motivo y decisión, en vez de listar los productos separados por comas.
// filas: [{ descripcion, cantidad, unidad, detalle }]
// encabezadoCantidad: título de la columna de cantidad (ej. "Sin aprobar").
// tono: "naranja" | "rojo" | "verde" | "azul" — color de la cantidad.
const TONOS = {
  naranja: { color: "#b85a0b", bg: "#fde6cf" },
  rojo: { color: "#a3402f", bg: "#f7ded9" },
  verde: { color: "#2f7a54", bg: "#dcf0e6" },
  azul: { color: "#1d5fa8", bg: "#d7e8f7" },
};

function TablaProductosModal({ filas, encabezadoCantidad = "Cantidad", encabezadoExtra, tono = "azul" }) {
  if (!filas || filas.length === 0) return null;
  const t = TONOS[tono] || TONOS.azul;
  const hayExtra = !!encabezadoExtra;

  return (
    <div style={styles.contenedor}>
      <table style={styles.tabla}>
        <thead>
          <tr>
            <th style={{ ...styles.th, width: 34 }}>#</th>
            <th style={styles.th}>Producto</th>
            <th style={{ ...styles.th, textAlign: "center" }}>{encabezadoCantidad}</th>
            {hayExtra && <th style={{ ...styles.th, textAlign: "center" }}>{encabezadoExtra}</th>}
          </tr>
        </thead>
        <tbody>
          {filas.map((f, i) => (
            <tr key={`${f.descripcion}-${i}`} style={{ borderTop: "1px solid #eef1f3" }}>
              <td style={{ ...styles.td, color: "#8993a1" }}>{i + 1}</td>
              <td style={{ ...styles.td, lineHeight: 1.3 }}>{f.descripcion}</td>
              <td style={{ ...styles.td, textAlign: "center", whiteSpace: "nowrap" }}>
                <span style={{ ...styles.pastilla, color: t.color, background: t.bg }}>
                  {f.cantidad}
                  {f.unidad ? ` ${f.unidad}` : ""}
                </span>
              </td>
              {hayExtra && (
                <td style={{ ...styles.td, textAlign: "center", whiteSpace: "nowrap", color: "#5b6472" }}>
                  {f.detalle}
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

const styles = {
  contenedor: { border: "1px solid #e2e6ea", borderRadius: 10, overflow: "hidden", margin: "0.8rem 0", maxHeight: 260, overflowY: "auto" },
  tabla: { width: "100%", borderCollapse: "collapse", fontSize: "0.85rem", color: "var(--tema-titulo, #0b3c60)" },
  th: {
    padding: "0.45rem 0.7rem",
    background: "#eef1f3",
    fontSize: "0.72rem",
    fontWeight: 700,
    color: "var(--tema-titulo, #0b3c60)",
    textAlign: "left",
    whiteSpace: "nowrap",
    position: "sticky",
    top: 0,
  },
  td: { padding: "0.5rem 0.7rem", verticalAlign: "middle" },
  pastilla: { display: "inline-block", borderRadius: 999, padding: "0.12rem 0.6rem", fontSize: "0.78rem", fontWeight: 700 },
};

export default TablaProductosModal;
